<template>
  <div class="login-form" style="background:#e8f0fe ">
    <div class="login-box">
      <img :src="bkImg" style="height: 100%; flex-shrink: 0;width: calc(100% - 452px);" />
      <div class="login-input" >
        <!-- <img :src="logoImg" />-->
        <span class="title">重置密码</span>
        <el-form :model="dataForm" :rules="dataRule" label-width="80px"  ref="dataForm"
                 @keyup.enter.native="dataFormSubmit()" style="width: 400px; margin-top: 4vh;">
          <el-col :span="24">
            <el-form-item label="手机号" prop="userPhone">
              <el-input v-model="dataForm.userPhone" style="width: 100%;" placeholder="手机号"></el-input>
            </el-form-item>
          </el-col>

          <el-col :span="24">
            <el-form-item label="密码" prop="newpassword">
              <el-input v-model="dataForm.newpassword" style="width: 100%;" type="password" placeholder="密码"
                        show-password></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="重复密码" prop="newpassword1">
              <el-input v-model="dataForm.newpassword1" style="width: 100%;" type="password" placeholder="确认密码密码"
                        show-password></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="16">
            <el-form-item label="验证码" prop="captcha">

              <el-input style="flex: 1;width: 100%;" placeholder="请输入验证码"
                        :custom-style="{background:'#f8f8f8',padding:'5rpx 20rpx',borderRadius:'50rpx',margin:'5rpx 0'}"
                        v-model="dataForm.captcha" type="text"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="4">

            <div :class="isDisabled?'codebtn2':'codebtn'" @click="getCode()" >
              <div>{{codeName}}</div>
            </div>
          </el-col>
          <el-button class="login-btn-submit" type="warning" style="width: 100%;"
                     @click="dataFormSubmit()"
                     :loading="isHttpLoading">
            确定
          </el-button>
          <div style="float: right;margin-top: 10px"><a href="javascript:void(0)" @click="toRegister()">返回</a></div>
        </el-form>
      </div>
    </div>
    <Verify
      ref="verify"
      @success="onVerifySuccess"
      :mode="'pop'"
      captchaType="blockPuzzle"
      :imgSize="{ width: '330px', height: '155px' }"
    />
  </div>
</template>

<script>
import { SystemController } from '@/api';
import { mapMutations } from 'vuex';
import { encrypt, setToken } from '@/utils';
import Verify from '@/components/Verifition/Verify.vue';

export default {
  components: {
    Verify
  },
  data () {
    return {
      codeName: '获取验证码',
      isDisabled: false,
      time: 180,
      buttonDisabled: false,
      bkImg: require('@/assets/img/login.png'),
      /* logoImg: require('@/assets/img/login_logo.png'), */
      dataForm: {
        mobilePhone: '',
        newpassword: '',
        newpassword1: '',
        captcha: ''
      },
      dataRule: {
        userPhone: [
          { required: true, message: '手机号不能为空', trigger: 'blur' },
          {
            required: true, pattern: /^[1][3,4,5,7,8,9][0-9]{9}$/, message: '请输入正确的手机号码', trigger: 'blur'
          }
        ],
        newpassword: [
          { required: true, message: '密码不能为空', trigger: 'blur' },
          {
            required: true, pattern: /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[^]{8,16}$/g, message: '密码8-16位，应该包含大小写字母和数字', trigger: 'blur'
          }],
        newpassword1: [{
          required: true,
          message: '请输入重复密码',
          trigger: ['change', 'blur']
        }]
      }
    };
  },
  methods: {
    dataFormSubmit () {
      this.$refs['dataForm'].validate(valid => {
        if (valid) {
          if (this.dataForm.captcha === '') {
            this.$message.warning('请输入验证码')
          } else if (this.dataForm.newpassword !== this.dataForm.newpassword1) {
            this.$message.warning('两次密码不一致')
          } else {
            this.update()
          }
        }
      });
    },
    update () {
      let params = {
        userPhone: this.dataForm.userPhone,
        password: encrypt(this.dataForm.newpassword),
        captcha: this.dataForm.captcha
      };
      SystemController.resetPassword(this, params, null, {showMask: false}).then(data => {
        setTimeout(() => {
          this.$router.replace({ name: 'login' });
        }, 1000)
      }).catch(e => {});
    },
    toRegister () {
      this.$router.replace({ name: 'login' });
    },
    getCaptcha (verifyParams) {
      let that = this
      let params = {
        userPhone: this.dataForm.userPhone,
        captchaVerification: (verifyParams || {}).captchaVerification
      };
      // setToken(null);
      SystemController.getCaptcha(this, params, null, {showMask: false}).then(data => {
        that.isDisabled = true;
        let interval = window.setInterval(function () {
          that.codeName = that.time + '秒后重新发送';
          --that.time;
          if (that.time < 0) {
            that.codeName = '重新发送';
            that.time = 180;
            that.isDisabled = false;
            window.clearInterval(interval);
          }
        }, 1000);
      }).catch(e => {});
    },
    onVerifySuccess (verifyParams) {
      this.getCaptcha(verifyParams);
    },
    getCode () {
      this.$refs['dataForm'].validate(valid => {
        if (valid) {
          this.$refs.verify.show();
        }
      });
    },
    ...mapMutations(['setUserInfo', 'setMenuList', 'setCurrentMenuId'])
  }

};
</script>

<style lang="scss">
  .login-form {
    width: 100vw;
    height: 100vh;
    background: #292D36;
    display: flex;
    justify-content: center;
    align-items: center;
    .login-box {
      display: flex;
      align-items: center;
      height: 70vh;
      padding: 7vh;
      border-radius: 3px;
      background: white;
      .login-input {
        height: 100%;
        width: 420px;
        display: flex;
        align-items: center;
        flex-direction: column;
        img {
          width: 356px;
          height: 42px;
          margin-top: 6vh;
        }
        .title {
          color: #232323;
          font-size: 20px;
          margin-top: 3vh;
        }
      }
    }
  }
  .login-form .el-button {
    height: 45px!important;
    font-size: 20px;
  }
  .codebtn {
    width: 120px;
    height: 40px;
    font-size: 11px;
    color: white;
    display: flex;
    flex-direction: row;
    align-items: center;
    border-radius: 10px;
    justify-content: center;
    background-color: #009dff;
    margin-left: 10px;
  }
  .codebtn2{
    width: 120px;
    height: 40px;
    font-size: 11px;
    color: white;
    display: flex;
    flex-direction: row;
    align-items: center;
    border-radius: 10px;
    justify-content: center;
    background-color: #009dff;
    margin-left: 10px;
    pointer-events: none; // 禁止鼠标点击事件
  }
</style>
